import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { SegmentControl } from '@blade/ui-kit'
import {
  relationDrawerDelugeIdAtom,
  relationTabAtom,
} from '@root/features/user/profile-header/atoms'
import { Drawer } from '@root/shared/ui-kit'

import { relationViewEvent } from '../atoms'

import { RelationFollowersFilter } from './relation-followers-filter'
import { RelationFollowingsFilter } from './relation-followings-filter'

export type RelationsDrawerTab = 'followers' | 'followings'

type Props = {}

export const RelationsDrawer: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(relationTabAtom)
  const [openedWithDelugeId, setOpenedWithDelugeId] = useAtom(
    relationDrawerDelugeIdAtom,
  )

  relationViewEvent.onCall(() => setOpenedWithDelugeId(undefined))

  const handleDrawerClose = () => setOpenedWithDelugeId(undefined)

  const RelationFilter =
    tab === 'followers' ? RelationFollowersFilter : RelationFollowingsFilter

  return (
    <Root open={!!openedWithDelugeId} onOpenChange={handleDrawerClose}>
      <Content>
        <TabsContainer>
          <SegmentControl size="h30" value={tab} onChange={setTab}>
            <Tab value={'followers' satisfies RelationsDrawerTab}>
              {t('common.follower_other')}
            </Tab>
            <Tab value={'followings' satisfies RelationsDrawerTab}>
              {t('common.following_other')}
            </Tab>
          </SegmentControl>
        </TabsContainer>

        {openedWithDelugeId ? (
          <RelationFilter delugeId={openedWithDelugeId} />
        ) : undefined}
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
  background: var(--background-1);
`

const Content = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding-block: 16px 0;
  height: 100%;
  gap: 16px;
`

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
`

const Tab = styled(SegmentControl.Item)`
  text-transform: capitalize;k 
`
